import {
    FULL_COMPOSE_ENTRY_SOURCE_UNDO,
    FullComposeEntrySourceType,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON,
    QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE,
    QuickComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

export default function isEntrySourceUndo(
    entrySource: QuickComposeEntrySourceType | FullComposeEntrySourceType
): boolean {
    return (
        entrySource == QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON ||
        entrySource == QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE ||
        entrySource == QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT ||
        entrySource == FULL_COMPOSE_ENTRY_SOURCE_UNDO
    );
}
